import { render, staticRenderFns } from "./SummaryReportOfStudentsProgressReport.vue?vue&type=template&id=b07472f0&"
import script from "./SummaryReportOfStudentsProgressReport.vue?vue&type=script&lang=js&"
export * from "./SummaryReportOfStudentsProgressReport.vue?vue&type=script&lang=js&"
import style0 from "./SummaryReportOfStudentsProgressReport.vue?vue&type=style&index=0&id=b07472f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports